export const lightTheme = {
  name: "light",
  baseColor: "rgba(255, 255, 255, 1)",
};

export const darkTheme = {
  name: "dark",
  baseColor: "rgba(0, 0, 0, 1)",
};
